
import AdminSidebar from './admin-sidebar';

export default function AdminLayout({ children }) {
    let sideMenuArr = [];
    if (localStorage.getItem('menubardata')) {
        const menuObj = localStorage.getItem('menubardata');
        if (menuObj) {
            try {
                const menuBar = JSON.parse(menuObj);
                sideMenuArr = menuBar?.dashboard?.[1]?.sideMenu || [];
            } catch (err) {
                console.error('Failed to parse menubardata:', err);
            }
        }
    }
    return (
        <div className="layout">
            <div className="sidebar">
                <AdminSidebar sideMenuArrProp={sideMenuArr} />
            </div>
            <div className="main">
                {children}
            </div>
        </div>
    );
}
